export default "__VITE_ASSET__F2VkxjCT__"